/**
 * Defines all steps to create a new secret santa.
 */
export const FormSteps = {
  /** First step to add participants. */
  ADD_PARTICIPANTS: 'participants',
  /** Second step to add exclusions. */
  ADD_EXCLUSIONS: 'exclusions',
  /** Third step to add a name and submit. */
  ADD_NAME_AND_SUBMIT: 'name',
} as const;

/** Defines all steps to create a new secret santa. */
export type FormStep = (typeof FormSteps)[keyof typeof FormSteps];

/**
 * Defines a single UI participant entry.
 * IDs are client-side only used to uniquely identify the participant.
 */
export interface Participant {
  id: string;
  name: string;
  exclusions: string[];
}
